// Miscellaneous Site Data - start
export const FETCH_MISC_SITE_DATA_REQUEST = 'FETCH_MISC_SITE_DATA_REQUEST';
export const FETCH_MISC_SITE_DATA_SUCCESS = 'FETCH_MISC_SITE_DATA_SUCCESS';
export const FETCH_MISC_SITE_DATA_FAILURE = 'FETCH_MISC_SITE_DATA_FAILURE';

export const FETCH_SITES_DROPDOWN_REQUEST = 'FETCH_SITES_DROPDOWN_REQUEST';
export const FETCH_SITES_DROPDOWN_SUCCESS = 'FETCH_SITES_DROPDOWN_SUCCESS';
export const FETCH_SITES_DROPDOWN_FAILURE = 'FETCH_SITES_DROPDOWN_FAILURE';

export const FETCH_PRACTICE_SITE_MAPPING_REQUEST = 'FETCH_PRACTICE_SITE_MAPPING_REQUEST';
export const FETCH_PRACTICE_SITE_MAPPING_SUCCESS = 'FETCH_PRACTICE_SITE_MAPPING_SUCCESS';
export const FETCH_PRACTICE_SITE_MAPPING_FAILURE = 'FETCH_PRACTICE_SITE_MAPPING_FAILURE';

export const SAVE_UPDATE_MISC_SITES_REQUEST = 'SAVE_UPDATE_MISC_SITES_REQUEST';
export const SAVE_UPDATE_MISC_SITES_SUCCESS = 'SAVE_UPDATE_MISC_SITES_SUCCESS';
export const SAVE_UPDATE_MISC_SITES_FAILURE = 'SAVE_UPDATE_MISC_SITES_FAILURE';

export const CLEAR_MISC_SITE_DATA = 'CLEAR_MISC_SITE_DATA';
// Miscellaneous Site Data - end